<template>
  <div class="blank">
    <img
      class="icon"
      src="@/assets/img/icon-blank.png"
    >
    <div class="text">{{ text }}</div>
  </div>
</template>

  <script>
export default {
  name: 'Blank',
  props: {
    text: {
      type: String,
      default: '暂无数据'
    }
  },
  data() {
    return {};
  },
  methods: {}
};
  </script>

  <style lang="scss" scoped>
  .blank {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .icon {
      width: 320px;
      height: 160px;
      object-fit: contain;
    }
    .text {
      font-size: 16px;
      color: #c8c8c8;
      text-align: center;
      font-weight: 400;
    }
  }
  </style>
